

export default function Home() {
    return (
        <div className="row">
            <img
                src="/ilustracio-craiteria-admin.png"  
                className="img-fluid rounded mx-auto d-block"
            />                
        </div>
    );
}